import type { EntityWithPermissions } from '@/types';

import type { AuthUser } from '../auth/schemas/oauth';

export interface WhitelistUser extends Pick<AuthUser, 'name' | 'email'>, EntityWithPermissions {}

export type WhitelistUserById = {
    [key: WhitelistUser['id']]: WhitelistUser;
};

export enum EntityKey {
    WHITELIST_USERS = 'whitelistUser',
}
